<template>
  <div id="app">
    <el-drawer :visible.sync="drawerVisible" :with-header="false" :direction="'btt'" size="auto"
      class="portfolio-drawer">
      <el-menu :default-active="$route.path" router class="drawer-menu" @select="handleDrawerSelect">
        <el-menu-item index="/website">
          <span slot="title">Website</span>
        </el-menu-item>
        <el-menu-item index="/art-design">
          <span slot="title">Art Design</span>
        </el-menu-item>
        <el-menu-item index="/industrial">
          <span slot="title">Industrial Design</span>
        </el-menu-item>
        <el-menu-item index="close" class="close-item">
          <i class="el-icon-close"></i>
        </el-menu-item>
      </el-menu>
    </el-drawer>
    <el-container>

      <el-aside width="200px" class="desktop-aside">
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" router>
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-reading"></i>
              <span>Portfolio</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/website">Website</el-menu-item>
              <el-menu-item index="/art-design">Art Design</el-menu-item>
              <el-menu-item index="/industrial">Industrial Design</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-menu-item index="/">
            <i class="el-icon-thumb"></i>
            <span slot="title">About</span>
          </el-menu-item>

          <el-menu-item index="/contact">
            <i class="el-icon-mobile-phone"></i>
            <span slot="title">Contact</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <el-main class="main-content"
        :class="{ 'no-padding-main': $route.path === '/website' || $route.path === '/contact' }">
        <transition name="el-fade-in-linear" mode="out-in">
          <router-view />
        </transition>
      </el-main>



    </el-container>
    <el-footer>
      <div class="copyright text-center">
        <h5>© Margo Chin</h5>
      </div>
    </el-footer>
    <el-menu :default-active="$route.path" class="mobile-bottom-nav" mode="horizontal" @select="handleBottomNavSelect"
      router>
      <el-menu-item index="portfolio-toggle">
        <i class="el-icon-reading"></i>
        <span slot="title">Portfolio</span>
      </el-menu-item>

      <el-menu-item index="/">
        <i class="el-icon-thumb"></i>
        <span slot="title">About</span>
      </el-menu-item>

      <el-menu-item index="/contact">
        <i class="el-icon-mobile-phone"></i>
        <span slot="title">Contact</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      drawerVisible: false,
      backgroundImage: require('@/assets/image/bg.png')
    }
  },
  mounted() {
    // 當元件掛載時，設定 body 的背景
    document.body.style.backgroundImage = `url(${this.backgroundImage})`;
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundAttachment = 'fixed'; // 讓背景圖固定不滾動
  },
  beforeDestroy() {
    // 當元件銷毀前，清除 body 的背景，避免影響其他頁面
    document.body.style.backgroundImage = '';
    document.body.style.backgroundSize = '';
    document.body.style.backgroundRepeat = '';
    document.body.style.backgroundAttachment = '';
  },
  methods: {
    // 側邊欄方法 (保留)
    handleOpen(key, keyPath) {
      console.log('選單開啟:', key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log('選單關閉:', key, keyPath);
    },

    // 處理手機底部導航的點擊事件
    handleBottomNavSelect(index) {
      if (index === 'portfolio-toggle') {
        // 點擊 Portfolio，切換抽屜狀態
        this.drawerVisible = true;
      } else if (index !== 'close') {
        // 點擊其他項目，導航並確保抽屜是關閉的
        this.drawerVisible = false;
        // 由於 El-menu 已經設為 router，這裡不需要手動跳轉
      }
    },

    // 【新增】處理抽屜內部選單的點擊事件
    handleDrawerSelect(index) {
      if (index === 'close') {
        this.drawerVisible = false; // 點擊關閉按鈕
      } else {
        // 點擊子選單項目，導航後關閉抽屜
        this.drawerVisible = false;
        // 由於 El-menu 已經設為 router，這裡不需要手動跳轉
      }
    }
  }
}
</script>

<style>
#app {
  height: 100vh;
  font-family: 'AtlantisFamingo';
  letter-spacing: 1.5px;

}

p,h4 {
  color: #333431;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
  /* 設置過渡時間和緩動函數 */
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

html,
body {
  height: 100%;
  /* 確保繼承視窗高度 */
  margin: 0;
  padding: 0;
}

.el-container,
.el-footer {
  background-color: #f5efe673;
}

.el-footer {
  justify-content: center;
  display: flex;
  align-items: center;
  font-size: 22px;

}

h2 {
  text-align: center;
  padding-top: 24px;
}

.el-container {
  height: 100%;
}

.no-padding-main {
  padding: 0 !important;
  padding-bottom: 0 !important;
}

.el-aside {
  margin: 16px;
  background-color: white !important;
  border-radius: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* --- 抽屜選單樣式 --- */
.portfolio-drawer>>>.el-drawer {
  /* 確保抽屜高度只佔滿內容，因為 size="auto" */
  height: auto !important;
  max-height: 80vh;
  /* 防止內容過多佔滿整個視窗 */
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.portfolio-drawer>>>.el-drawer__body {
  padding: 0;

}

.drawer-menu {
  border-right: none;
  margin-bottom: 60px !important;

}

.drawer-menu .el-menu-item {
  font-size: 16px;
  height: 50px;
  line-height: 50px;
}

.el-submenu {
  background-color: #ffffff !important;
}

.el-menu-item * {
  font-size: 16px;
}

.el-menu-item-group__title {
  padding: 0 !important;
}


.el-submenu__title:hover,
.el-menu-item:focus,
.el-menu-item:hover {
  background-color: #e1e1d0 !important;
}

.el-menu-item.is-active,
.el-menu-item.is-active i {
  color: rgb(48, 46, 46) !important;
}

.el-menu-item i,
.el-menu-item,
.el-submenu__title {
  color: #706551 !important;
}

.el-submenu__title,
.el-menu-item {
  align-items: center
}

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 2px solid #C2A68C !important;
  color: #303133;
}

/* --- 桌面版樣式 (> 768px) --- */
@media (min-width: 769px) {

  /* 顯示側邊欄 */
  .desktop-aside {
    display: block !important;
    width: 200px;
    /* 確保主內容沒有底部邊距 */
  }

  /* 隱藏底部導航欄 */
  .mobile-bottom-nav {
    display: none !important;
  }
}

/* --- 手機版樣式 (<= 768px) --- */
@media (max-width: 768px) {
  .el-image-viewer__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 60px !important;
    left: 0;
  }

  /* 1. 隱藏側邊欄 */
  .desktop-aside {
    width: 0px !important;
    /* 強制寬度為 0 */
    display: none !important;
  }

  /* 調整 el-footer 在手機上的行為，確保它不會與底部導航欄衝突 */
  .el-footer {
    /* 確保 el-footer 的層級低於導航欄，並避免它影響固定定位 */
    position: relative;
    /* 確保內容在正常流中 */
    z-index: 1;
    height: 120px !important;
    padding-bottom: 16% !important;

  }

  .el-image-viewer__img {
    padding: 5%;
  }

  .mobile-bottom-nav {
    display: flex !important;
    position: fixed !important;
    bottom: 0 !important;
    left: 0;
    margin-top: 24px !important;
    width: 100%;
    height: 60px;
    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
    z-index: 9999 !important;
    padding: 0;
    margin: 0;
    border-right: none;
  }


  /* 調整底部導航的項目 */
  .mobile-bottom-nav .el-menu-item {
    flex: 1;
    /* 平均分配空間 */
    height: 60px;
    line-height: 60px;
    padding: 0 5px;
    text-align: center;
    display: flex;
    flex-direction: column;
    /* 圖標和文字垂直排列 */
    justify-content: center;
  }

  /* 調整圖標和文字在手機菜單中的樣式 */
  .mobile-bottom-nav .el-menu-item i {
    margin-right: 0;
    font-size: 18px;
    height: 18px;
    /* 修正圖標大小 */
    line-height: 1;
  }

  .mobile-bottom-nav .el-menu-item span {
    height: 14px;
    line-height: 1;
    font-size: 10px;
    display: block;
    /* 確保文字換行 */
  }

  .el-menu-item span {
    align-items: center;
    font-size: 14px !important;
    margin-top: 8px;
  }


}

@media (min-width: 1200px) {}
</style>